/*
 * The user-agent input styling, undone: this package ships without Preflight.
 * A field that wants an edge writes one after — `cn` lets the later class win.
 */
export const INPUT_RESET =
  'sk:m-0 sk:appearance-none sk:border-0 sk:font-sans sk:shadow-none';
